import { useSelector } from "react-redux";
import { GameMetaType } from "../types";
import { RootState } from "../reducers";

export const useGameMeta = () => {
  const gameMeta: GameMetaType = useSelector(
    (state: RootState) => state.gameMeta
  );
  return gameMeta;
};
